<div class="is-my-lesson">
  <div class="is-my-lesson-text">
    {{'user-service-checkout-wizard.is-my-lesson-text' | customLocale}}
  </div>
</div>
